export const yellow = '#fff500'
export const slateGrey = '#6b6c6f'
export const coolGrey = '#a2a5a7'
export const paleGrey = '#e7e6e6'
export const placeholder = 'rgba(0,0,0, 0.1)'